import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_5vj7ku5zz3: FaireBrandEntity = {
  token: "b_5vj7ku5zz3",
  type: "brand",
  name: "Shoppe SHC",
  avatarUrl:
    "https://cdn.faire.com/fastly/639b662c2374b3179645ecb18063cda0cefd78bf2ca0eea6f366cae5b38f7bc0.webp",
  bannerUrl:
    "https://cdn.faire.com/fastly/0d715778b22ec0c927833c33365e98c2974c37511ffca5867fb604e14f99a162.webp",
  logoUrl:
    "https://cdn.faire.com/fastly/639b662c2374b3179645ecb18063cda0cefd78bf2ca0eea6f366cae5b38f7bc0.webp",
  heroImageUrl:
    "https://cdn.faire.com/fastly/0d715778b22ec0c927833c33365e98c2974c37511ffca5867fb604e14f99a162.webp",
  location: "Atlanta , GA, USA",
  minimumOrderDollars: 0,
  rating: 4.8,
  reviewCount: 128,
  isTopShop: true,
  isInsider: true,
  description:
    "Shoppe SHC  has two locations based out of Atlanta, GA.  and  Foley , AL.\nAll items are Proudly Printed & Produced 🇺🇸  In The USA 🇺🇸   within our own facilities \nBe sure to join our exclusive only for Faire Customers Group Page Here : https://www.facebook.com/groups/2267059383672231",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:35.700Z",
    importedBy: "entity-db-cli",
  },
};
